export class DeviceInfo {
    public BasePath: string = '';
    public ImmediatePrint: boolean = false;
    public ContentOnly: boolean = false;
    public UseSVG: boolean = false;
    public enableSearch: boolean = false;
    public enableAccessibility: boolean = false;
    public contentTabIndex: number = 0;
}
